import analytics from './logic/analytics/analytics.reducer';
import app from './logic/app/app.reducer';
import features from './logic/features/features.reducer';
import user from './logic/user/user.reducer';
import layout from './logic/layout/layout.reducer';
import lifecycle from './logic/lifecycle/lifecycle.reducer';
import lock from './logic/lock/lock.reducer';
import pairing from './logic/pairing/pairing.reducer';
import player from './logic/player/player.reducer';
import routing from './logic/routing/routing.reducer';
import search from './logic/search/search.reducer';
import gdpr from './logic/gdprNotice/gdprNotice.reducer';
import popup from './logic/popup/popup.reducer';
import screenSaver from './logic/screenSaver/screenSaver.reducer';

// TODO: retire the fakes
const fakeInitialState = {};
const fakeReducer = (state = fakeInitialState) => ({ ...state });

export default {
  analytics,
  app,
  features,
  error: () => fakeReducer,
  layout,
  lifecycle,
  lock,
  parentalCode: () => fakeReducer,
  pairing,
  player,
  routing,
  search,
  user,
  gdpr,
  popup,
  screenSaver,
};
